module.exports = __webpack_public_path__ + "static/img/flower_1.babfb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flower_1.png
// module id = dXSZ
// module chunks = 1